class headerObject {
  constructor(
    name,
    displayName,
    additionalDescription = "",
    imagePath = "",
    typeSetting = {},
    saveUnit = null,
    showUnit = null,
    digitsAfterComma = 0,
    bitCount = 16,
    mapsToBar = null,
    useColorControlPacketCorrecture = false
  ) {
    this.name = name;
    this.displayName = displayName;
    this.additionalDescription = additionalDescription;
    this.imagePath = imagePath;
    this.typeSetting = typeSetting;
    this.saveUnit = saveUnit;
    this.showUnit = showUnit;
    this.digitsAfterComma = digitsAfterComma;
    this.bitCount = bitCount;
    this.mapsToBar = mapsToBar;
    this.useColorControlPacketCorrecture = useColorControlPacketCorrecture;
  }
}

class typeSetting {
  constructor(
    hasMinMax = false,
    minValue = 0,
    maxValue = 100,
    defaultValue = 0,
    color = "rgba(256, 256, 0, 0.5)"
  ) {
    this.hasMinMax = hasMinMax;
    this.minValue = minValue;
    this.maxValue = maxValue;
    this.defaultValue = defaultValue;
    this.color = color;
  }
}

const pickTypesSettings = {
  PickDensityPer100m: new headerObject(
    "PickDensityPer100m",
    "Fabric Take-Off",
    "",
    require("../assets/take_off.svg"),
    new typeSetting(true, 3, 120, 30, "rgba(255, 0, 0, 0.5)"),
    "PICKSPER100M",
    "PICKSPERCM",
    2,
    32,
    null,
    true
  ),
  WeftTransportGear: new headerObject(
    "WeftTransportGear",
    "Weft Transport",
    "",
    require("../assets/weft_feeder.svg"),
    new typeSetting(true, 0, 250, 100, "rgba(0, 200, 0, 0.5)"),
    "PERCENT",
    "PERCENT",
    0,
    16,
    "0"
  ),
  BinderTransport: new headerObject(
    "BinderTransport",
    "Binder Transport",
    "",
    require("../assets/binder_feeder.svg"),
    new typeSetting(true, 0, 250, 100, "rgba(100, 255, 100, 0.5)"),
    "PERCENT",
    "PERCENT",
    0,
    16,
    null
  ),
  BinderTransportMColor: new headerObject(),
  ColorPicksPerPacket: new headerObject(),
  WarpTransportGear: new headerObject(
    "WarpTransportGear",
    "Warp Transport Gear Mode",
    "",
    require("../assets/warp_feeder.svg"),
    new typeSetting(true, 0, 250, 100, "rgba(0, 255, 255, 0.5)"),
    "PERCENT",
    "PERCENT",
    0,
    16,
    "0"
  ),
  WarpTransportPID: new headerObject(
    "WarpTransportPID",
    "Warp Transport Controlled",
    "",
    require("../assets/warp_feeder_pid.svg"),
    new typeSetting(true, 0, 250, 100, "rgba(255, 0, 255, 0.5)"),
    "PERCENT",
    "PERCENT",
    0,
    16,
    null
  ),
  MainSpeed: new headerObject(
    "MainSpeed",
    "Main Drive Speed",
    "",
    require("../assets/speed.svg"),
    new typeSetting(true, 150, 4000, 1000, "rgba(255, 0, 255, 0.5)"),
    "RPM",
    "RPM",
    0,
    16,
    null
  ),
  ReedY: new headerObject(),
  NeedleY: new headerObject(),
  Picot: new headerObject(),
  Filler: new headerObject(),
  Regulator: new headerObject(),
  RibbonWidthCmm: new headerObject(
    "RibbonWidthCmm",
    "Ribbon Width",
    "(NH)",
    require("../assets/ribbon_width.svg"),
    new typeSetting(true, 1, 150, 20, "rgba(200, 200, 30, 0.5)"),
    "CMM",
    "MM",
    2,
    16,
    null
  ),
  LabelRepeatNumber: new headerObject(),
  ClosedShedAngle: new headerObject(),
  WeftTransportCmm: new headerObject(
    "WeftTransportCmm",
    "Weft Transport mm",
    "(MLC)",
    require("../assets/weft_feeder.svg"),
    new typeSetting(true, 0, 150, 20, "rgba(100, 50, 50, 0.5)"),
    "CMM",
    "MM",
    2,
    16,
    null
  ),
  MDWGuideBarCmm: new headerObject(),
  MDWCombShaftCmm: new headerObject(),
  MDWCombShaftRotate: new headerObject(),
  MDWNeedlePos: new headerObject(),
  MDWYarnTransportCmm: new headerObject()
};

export { pickTypesSettings };
